<div class="chart-container" *ngIf="isChartReady && chartData && hasValidData()" [ngClass]="{'chart-small': isSmall}">
  <div class="chart-header" *ngIf="getChartTitle()">
    <h4 class="chart-title tooltip-wrapper">{{ getChartTitle() }} <span class="tooltip-text">{{this.chartData.title}}</span></h4>
    <p class="chart-subtitle" *ngIf="getChartSubtitle()">{{ getChartSubtitle() }}</p>
  </div>
  
  <div class="chart-wrapper" [ngClass]="{'bar-chart': chartData?.type === 'bar'}">
    <div 
      #chartContainer 
      class="plotly-chart" 
      [ngClass]="{'pie-chart': chartData?.type === 'pie' || chartData?.type === 'donut'}"
      [style.height.px]="isSmall ? 360 : 400"
      [style.display]="hasChartError() ? 'none' : 'block'">
    </div>
    <!-- Beta Badge -->
    <div class="visual-insights-beta">
      <span class="beta-text">Visual Insights</span>
      <span class="beta-badge">BETA</span>
    </div>
    
    <div *ngIf="hasChartError()" class="chart-error-display">
      <strong>{{'CHART_ERROR_TEXT' | translate}}</strong> {{ getChartError() }}
    </div>
  </div>
</div>

<div class="chart-error" *ngIf="!isChartReady && chartData">
  <div class="error-message">
    <p>{{'UNABLE_TO_RENDER_CHAT_ERROR' | translate}}</p>
  </div>
</div>

<div class="chart-error" *ngIf="isChartReady && chartData && !hasValidData()">
  <div class="error-message">
    <p>{{'CHART_DATA_INVALID' | translate}}</p>
  </div>
</div>

<div class="chart-loading" *ngIf="!chartData">
  <div class="loading-spinner">
    <div class="spinner"></div>
    <p>{{'LOADING_CHART' | translate}}</p>
  </div>
</div> 